(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["welcome-popup"]) return;
  try {
    
  if (!customElements.get('welcome-popup')) {
    class WelcomePopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.form = this.querySelector('form');
        this.success = this.querySelector('[data-welcome-success]');
        this.storageKey = 'tws-welcome-popup-dismissed';
        this.completeKey = 'tws-welcome-popup-complete';

        this.querySelectorAll('[data-welcome-close]').forEach((button) => {
          button.addEventListener('click', () => this.close());
        });

        this.dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          this.close();
        });

        this.form?.addEventListener('submit', () => this.preparePhone());
        this.querySelector('[data-copy-code]')?.addEventListener('click', () => this.copyCode());

        if (this.success) {
          localStorage.setItem(this.completeKey, String(Date.now()));
          this.open();
          this.applyDiscount();
          return;
        }

        if (this.dataset.enabled !== 'true' || Shopify.designMode || this.wasRecentlySeen()) return;
        this.timer = window.setTimeout(() => this.open(), Number(this.dataset.delay) || 5000);
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
      }

      wasRecentlySeen() {
        const complete = Number(localStorage.getItem(this.completeKey));
        if (complete) return true;
        const dismissed = Number(localStorage.getItem(this.storageKey));
        const repeatMs = (Number(this.dataset.repeatDays) || 7) * 86400000;
        return dismissed && Date.now() - dismissed < repeatMs;
      }

      open() {
        document.documentElement.style.overflow = 'hidden';
        if (typeof this.dialog.showModal === 'function' && !this.dialog.open) this.dialog.showModal();
        else this.dialog.setAttribute('open', '');
        window.requestAnimationFrame(() => this.success?.focus());
      }

      close() {
        localStorage.setItem(this.storageKey, String(Date.now()));
        document.documentElement.style.overflow = '';
        if (this.dialog.open && typeof this.dialog.close === 'function') this.dialog.close();
        else this.dialog.removeAttribute('open');
      }

      preparePhone() {
        const local = this.querySelector('[data-local-phone]');
        const full = this.querySelector('[data-full-phone]');
        if (!local || !full) return;
        let digits = local.value.replace(/\D/g, '');
        if (digits.startsWith('0')) digits = digits.slice(1);
        full.value = `+972${digits}`;
      }

      async applyDiscount() {
        const code = this.dataset.discountCode;
        if (!code) return;
        try {
          await fetch(`/discount/${encodeURIComponent(code)}?redirect=/cart.js`, {
            credentials: 'same-origin'
          });
        } catch (error) {
          this.querySelector('[data-automatic-message]')?.setAttribute('data-apply-failed', 'true');
        }
      }

      async copyCode() {
        try {
          await navigator.clipboard.writeText(this.dataset.discountCode || '');
        } catch (error) {
          return;
        }
      }
    }

    customElements.define('welcome-popup', WelcomePopup);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["whatsapp-split-widget"]) return;
  try {
    
  const normalizeWhatsAppNumber = (value) => {
    const digits = String(value || '').replace(/\D/g, '');
    return digits.startsWith('0') ? `972${digits.slice(1)}` : digits;
  };

  document.querySelectorAll('[data-whatsapp-split-widget]').forEach((widget) => {
    if (widget.dataset.initialized === 'true') return;
    widget.dataset.initialized = 'true';

    const link = widget.querySelector('a');
    const primaryNumber = normalizeWhatsAppNumber(widget.dataset.primaryNumber);
    const alternateNumber = normalizeWhatsAppNumber(widget.dataset.alternateNumber);
    const alternateEvery = Math.max(2, Number.parseInt(widget.dataset.alternateEvery, 10) || 5);
    const message = widget.dataset.message || '';
    link.addEventListener('click', () => {
      const selectedNumber = Math.random() < 1 / alternateEvery ? alternateNumber : primaryNumber;
      link.href = `https://wa.me/${selectedNumber}?text=${encodeURIComponent(message)}`;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
